<template>
  <Content>
    <template #body>
      <div v-loading="loading" class="hidden-sections">
        <div v-if="digestName" class="hidden-sections__digest">
          Дайджест: <strong>{{ digestName }}</strong>
        </div>

        <div class="hidden-sections__label">Скрыть</div>

        <el-checkbox-group
          v-model="selectedIds"
          class="hidden-sections__group"
        >
          <div
            v-for="section in sections"
            :key="section.id"
            class="hidden-sections__row"
          >
            <el-checkbox
              :label="section.id"
              :disabled="section.hidden"
            >
              {{ section.name }}
              <span
                v-if="section.hidden"
                class="hidden-sections__badge"
              >
                скрыт глобально
              </span>
            </el-checkbox>
          </div>
        </el-checkbox-group>

        <div v-if="hasGloballyHidden" class="hidden-sections__note">
          Разделы с пометкой «скрыт глобально» уже не отображаются на сайте
          ни в одном дайджесте — их состояние в этом списке изменить нельзя.
          Чтобы вернуть такой раздел, снимите глобальный флаг на
          <router-link to="/site-section/list">странице разделов</router-link>.
        </div>

        <div class="hidden-sections__footer">
          <el-button @click="onCancel">Назад</el-button>
          <el-button
            type="primary"
            :loading="saving"
            @click="onApply"
          >
            Применить изменения
          </el-button>
        </div>
      </div>
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";

import {
  getDigestID,
  putDigestHiddenSections,
} from "@/api/digest";
import { getSiteSections } from "@/api/siteSection";

export default {
  components: {
    Content,
  },
  data() {
    return {
      loading: true,
      saving: false,
      digestName: "",
      sections: [],
      selectedIds: [],
    };
  },
  computed: {
    digestId() {
      return Number(this.$route.params.id);
    },
    hasGloballyHidden() {
      return this.sections.some((s) => s.hidden);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const [digest, sectionsResp] = await Promise.all([
          getDigestID(this.digestId),
          getSiteSections({ sort: "priority", limit: 100 }),
        ]);

        this.digestName = digest.name || "";

        const items = (sectionsResp && sectionsResp.items) || [];
        this.sections = items.slice().sort(
          (a, b) => (a.priority ?? 0) - (b.priority ?? 0)
        );

        const hidden = digest.hidden_sections || [];
        this.selectedIds = hidden.map((s) => s.id);
      } catch (err) {
        console.log(err);
        this.$message({
          type: "error",
          message: "Не удалось загрузить данные.",
        });
      } finally {
        this.loading = false;
      }
    },
    async onApply() {
      this.saving = true;
      try {
        // Отправляем только id разделов, которые пользователь может изменить.
        // Глобально скрытые в чекбоксы недоступны — их состояние PUT полностью
        // перезапишет, поэтому их в payload не добавляем.
        const editableIds = new Set(
          this.sections.filter((s) => !s.hidden).map((s) => s.id)
        );
        const payload = this.selectedIds.filter((id) => editableIds.has(id));

        await putDigestHiddenSections(this.digestId, {
          sections: payload,
        });

        this.$message({
          type: "success",
          message: "Изменения сохранены.",
        });
        this.$router.push("/digest/list");
      } catch (err) {
        console.log(err);
        this.$message({
          type: "error",
          message: "Не удалось сохранить изменения.",
        });
      } finally {
        this.saving = false;
      }
    },
    onCancel() {
      this.$router.push("/digest/list");
    },
  },
};
</script>

<style lang="scss" scoped>
.hidden-sections {
  &__digest {
    margin-bottom: 16px;
    color: #606266;
  }

  &__label {
    font-size: 13px;
    color: #909399;
    margin-bottom: 10px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }

  &__group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 24px;
  }

  &__row {
    display: flex;
    align-items: center;
  }

  &__badge {
    margin-left: 8px;
    font-size: 12px;
    color: #c0c4cc;
    font-style: italic;
  }

  &__note {
    padding: 12px 14px;
    background: #fdf6ec;
    color: #8a6d3b;
    border-left: 3px solid #e6a23c;
    margin-bottom: 24px;
    font-size: 13px;
    line-height: 1.5;
  }

  &__footer {
    display: flex;
    gap: 10px;
    padding-top: 10px;
    border-top: 1px solid #ebeef5;
  }
}
</style>
